import { Modal, SIZES } from "@mallardbay/lib-react-components"
import React from "react"
import queryString from "query-string"

import SignInOrContinueAsGuestForm from "~components/pages/listing/checkout/sign-in-or-continue-as-guest-form"
import COPY from "~config/copy-constants"
import { CHECKOUT_STEPS, QUERY_STRING_PROPS } from "~config/constants"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"

interface Props {
    readonly isOpen: boolean
    readonly onClose: () => void
}

export default function SignInOrGuestModal({ isOpen, onClose }: Props) {
    const authZeroReturnTo = useAuthZeroReturnTo()
    const { goToNextStep } = useCheckoutFlow()

    return (
        <Modal
            title={COPY.HOW_WOULD_YOU_LIKE_TO_CONTINUE}
            isOpen={isOpen}
            onClose={onClose}
            size={SIZES.MD}
            shouldAddPadding
        >
            <SignInOrContinueAsGuestForm
                onGuestLoginSuccess={goToNextStep}
                authZeroReturnTo={authZeroReturnTo}
            />
        </Modal>
    )
}

function useAuthZeroReturnTo() {
    const { checkoutQueryParams } = useCheckoutFlow()

    const paramsWithTargetStep = {
        ...checkoutQueryParams,
        [QUERY_STRING_PROPS.STEP]: CHECKOUT_STEPS.PAYMENT,
    }
    const paramsString = queryString.stringify(paramsWithTargetStep)

    return `${window.location.pathname}?${paramsString}`
}
